import { generateId } from '@freelancer/datastore/testing';
import { HourlyContractBillingCycleApi } from 'api-typings/projects/projects';
import { HourlyContract } from './hourly-contracts.model';

export interface GenerateHourlyContractOptions {
  readonly projectId: number;
  readonly bidId: number;
  readonly currentHourlyRate?: number;
  readonly currentWorkLimit?: number;
}

export function generateHourlyContractObject({
  projectId,
  bidId,
  currentHourlyRate = 20,
  currentWorkLimit = 40,
}: GenerateHourlyContractOptions): HourlyContract {
  return {
    id: generateId(),
    projectId,
    bidId,
    billingCycle: HourlyContractBillingCycleApi.WEEKLY,
    invoicePaymentMethod: 'automatic',
    currentHourlyRate,
    currentWorkLimit,
  };
}
